import { Button, Col, Form, Row } from "react-bootstrap";
import { ParamView, SortKey, SortOrder } from "./useSortedFilteredParams";

export type QueryParamControlsProps = {
  readonly view: ParamView;
  readonly onViewChange: (view: ParamView) => void;
  readonly onCopyParameters: () => void;
  readonly onExport: () => void;
};

const QueryParamControls = ({ view, onViewChange, onCopyParameters, onExport }: QueryParamControlsProps) => (
  <Row className="g-2 mb-3 align-items-center">
    <Col md={5}>
      <Form.Control
        type="text"
        placeholder="Filter by parameter name"
        aria-label="Filter parameters"
        value={view.filter}
        onChange={(e) => onViewChange({ ...view, filter: e.target.value })}
      />
    </Col>
    <Col md={3}>
      <Form.Select
        aria-label="Sort by"
        value={view.sortKey}
        onChange={(e) => onViewChange({ ...view, sortKey: e.target.value as SortKey })}
      >
        <option value="urlCount">URL Count</option>
        <option value="count">Occurrences</option>
        <option value="name">Name</option>
      </Form.Select>
    </Col>
    <Col md={2}>
      <Form.Select
        aria-label="Sort order"
        value={view.sortOrder}
        onChange={(e) => onViewChange({ ...view, sortOrder: e.target.value as SortOrder })}
      >
        <option value="desc">Descending</option>
        <option value="asc">Ascending</option>
      </Form.Select>
    </Col>
    <Col md={2} className="d-flex gap-2">
      <Button variant="outline-secondary" className="w-100" onClick={onCopyParameters}>
        Copy Parameters
      </Button>
      <Button variant="outline-secondary" className="w-100" onClick={onExport}>
        Export CSV
      </Button>
    </Col>
  </Row>
);

export default QueryParamControls;
